import React, { useEffect, useRef } from "react";
import "./Layout.css";
import { useLocation, useNavigate } from "react-router-dom";
import TransitionModal from "../TransitionModal/TransitionModal";
import { selectStudent } from "../../reduxSlices/studentSlice";
import { useSelector } from "react-redux";
import { EstadoAlumnoCarrera } from "../../enums/alumnoCarrera.enum";
import ModeHeader from "../ModeHeader/ModeHeader";
import DesktopHeader from "../DesktopHeader/DesktopHeader";
import { selectPanelFilters, setMobileFeatures, selectFlags, setHasRedirectedToCarrera, selectIsLoggingOut } from "../../reduxSlices/globalFlagsSlice";
import PanelDrawer from "../PanelDrawer/PanelDrawer";
import { selectDetailSubjectOffered } from "../../reduxSlices/subjectsSlice";
import PanelFilters from "../PanelFilters/PanelFilters";
import { selectParameter, setServerError } from "../../reduxSlices/parametersSlice";
import { useAppDispatch } from "../../app/store";
import { useToastError } from "../../hooks/useToast";



interface IPropsLayout {
  children: React.ReactNode;
  sessionExpired: boolean;
}

const DesktopLayout = ({ children, sessionExpired }: IPropsLayout) => {
  const dispatch = useAppDispatch();
  const student = useSelector(selectStudent);
  const { serverError, appState } = useSelector(selectParameter);
  const detailSubjectOffered = useSelector(selectDetailSubjectOffered);
  const panelFilters = useSelector(selectPanelFilters);
  const { hasRedirectedToCarrera } = useSelector(selectFlags);
  const isLoggingOut = useSelector(selectIsLoggingOut);
  const showError = useToastError();

  const location = useLocation();
  const navigate = useNavigate();
  const micrsoftSession = sessionStorage.getItem("msal.account.keys");   
  const hasRedirected = useRef(false);

  useEffect(() => {
    // set OFF mobile features
    dispatch(setMobileFeatures(false));
    const token = localStorage.getItem("token");
    const campusToken = localStorage.getItem("campusToken");

    if (student.bloqueoActivo && !isLoggingOut) {
      navigate("/bloqueo");
    }
    if (serverError) {
      const errorMessage = "<p style='white-space: nowrap'>Por favor intentá de nuevo en unos minutos.</p><p>De persistir el problema avisanos por acá: <a href='https://utdt.edu/soporte' target='_blank' rel='noopener noreferrer' style='color: #2277da; text-decoration: none;'>utdt.edu/soporte</a></p>";
      showError(errorMessage, undefined, "Surgió un error", false);
      dispatch(setServerError(false));
    }
    if (sessionExpired) {
      localStorage.clear()
      sessionStorage.clear();
      console.log("sessionExpired>> REDIRIGIENDO A LOGIN", {token, campusToken});
      navigate("/login");
    }
    if(location.pathname==="/" && (!micrsoftSession && appState==="0") && localStorage.getItem("token")===null){
      localStorage.clear()
      console.log("sessionExpired 2>> REDIRIGIENDO A LOGIN", {token, campusToken});
      navigate("/login");
    }
    if (!hasRedirectedToCarrera && student.listadoCarreras?.length > 1 && student.studentInitState === 2) {
      dispatch(setHasRedirectedToCarrera(true));
      navigate('/carrera');
    }

  }, [serverError, sessionExpired, student.bloqueoActivo, student.listadoCarreras?.length, student.studentInitState, hasRedirectedToCarrera, isLoggingOut]);
  
  return (
    <div className="desktop-layout">
      <ModeHeader />
      {/* ------------------------------- HEADER Menu ------------------------------ */}
      {location.pathname === "/" && <DesktopHeader />}
      {/* -------------------------------- CHILDREN -------------------------------- */}
      <div className="desktop-layout-content">{children}</div>
      {/* -------------------------------------------------------------------------- */
      /*                                   MODALES                                  */
      /* -------------------------------------------------------------------------- */}
      {/* ------------------------------ MODAL General ----------------------------- */}
      {student.id === 0 && !student.bloqueoActivo && location.pathname === "/" && (
        <TransitionModal open={true} text={"logoAnimado"} />
      )}
      {/* --------------------------- MODAL Inicializando -------------------------- */}
      {student.studentInitState === EstadoAlumnoCarrera.INICIALIZACION_KV_PENDIENTE && (
        <TransitionModal
          open={true}
          text={"Inicializando la información del alumno. Esta operación puede demorar unos minutos."}
        />
      )}
      {/* --------------------------- Overlay espera -------------------------- */}
      {/* {inTransitInscriptionRequet && <ModalOverlay text={""} />} */}
      {/* ----------------------- Panel Drawe Subject Detail ----------------------- */}
      {location.pathname !== "/login" && detailSubjectOffered && <PanelDrawer subject={detailSubjectOffered} />}
      {location.pathname !== "/login" && panelFilters && <PanelFilters />}
    </div>
  );
};

export default DesktopLayout;